import Component from '../inherited/Component'
import axios from 'axios'
import rivets from 'rivets'

export default class DynamicColourPicker extends Component {
  constructor (elem, theme, options, ctx) {
    super(elem, theme, options, ctx)
    this._endpoint = `/?view=ajax-ral-colors`
  }

  _binders () {
    rivets.formatters.getShade = (items, shade) => {
      return items.filter(item => item.category === shade)
    }

    rivets.formatters.length = (items) => {
      return items.length
    }

    rivets.formatters.minus = (one, two) => {
      return one - two
    }

    rivets.formatters.eq = (one, two) => {
      return one === two
    }

    rivets.formatters.limit = (items, limit) => {
      return items.slice(0, limit)
    }

    rivets.binders.background = function(el, value) {
      el.style.background = value
    }
  }

  async mount () {
    this._binders()

    if (this._options.defaultColor.title) {
      this._ctx.on('konva--ready', (state, data) => {
        this._ctx.emit('konva-set-colour', null, this._options.defaultColor)
      })
    }

    let allItems = []

    await Promise.all([1,2,3,4].map(async page => {
      let { data: items } = await axios.get(`${this._endpoint}&${this._options.pageQuery}=${page}`)
      allItems = [...allItems, ...items]
    }))

    allItems.sort((a, b) => {
      if (a.featured && !b.featured) return -1
      if (b.featured && !a.featured) return 1
      if (a.title < b.title) return -1
      if (a.title > b.title) return 1
      return 0
    })

    this._data = {
      items: allItems,
      activeColour: this._options.defaultColor?.title
    }

    rivets.bind(this._elem, {
      data: this._data,
      controller: {
        changeColour: (e, model) => {
          this._data.activeColour = model.item.title
          this._ctx.emit('konva-set-colour', null, model.item)
        }
      }
    })

    this._elem.classList.remove('loading')
  }
}